// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/loaders/stylePostLoader.js!./~/postcss-loader!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib?{}!./assets/vue/houseModel/components/savingNotification.vue?vue&type=style&index=0&lang=scss&
// module id = 162
// module chunks = 0